import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmProjectCustomerNotificationsTemplateRoute: InvariantJiraRoute = {
	name: 'csm-project-customer-notifications-template',
	path: '/jira/customer-service-management/projects/:projectKey/settings/:helpCenterId/customer-notifications/template',
	exact: true,
};
